// This file was automatically generated from ptdata.letterReceipts.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.letterReceipts');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.letters.attachments');
goog.require('el8.template.ptdata.letters');
goog.require('el8.template.render.reportFeedItem.referralDetail');
goog.require('el8.template.render.signOff');
goog.require('el8.template.shared.commentReplyForm');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letterReceipts.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8LetterHeaderWrap">', (el8Globals.PASSPORT_EMR && el8Globals.APP == 'home' && ! opt_data.signDate) ? '<div class="fr"><button type="button" class="el8PrimaryButton ebs-btn ebs-btn-primary el8LargeButton launch-patient-trigger"data-id="' + soy.$$escapeHtml(opt_data.patientId) + '">View All</button></div>' : '', '<p class="el8333">From: <span class="el8Bold">', (opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.senderName) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.senderName)) : soy.$$escapeHtml(opt_data.senderName)), '</span></p>', (el8Globals.PASSPORT_EMR && opt_data.receiverName) ? '<p class="el8333">To: <span class="el8Bold">' + soy.$$escapeHtml(opt_data.receiverName) + '</span></p>' : '', (opt_data.isPtLetter) ? '<p class="el8333">Sent on: <span class="el8Bold">' + (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : '') + '</span> at <span class="el8Bold">' + (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyTime(soy.$$escapeHtml(opt_data.documentDate)) : '') + '</span></p>' : (opt_data.sentDate && opt_data.signDate) ? '<p class="el8333">Sent on: <span class="el8Bold">' + (soy.$$escapeHtml(opt_data.sentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.sentDate)) : '') + '</span></p>' : '', (! el8Globals.PASSPORT_EMR) ? '<div class="fr ebs-pull-right"><button type="button" class="el8ShortButton ebs-btn ebs-btn-default ebs-btn-sm letter-toggle-collapse-trigger">show more</button></div>' : '', '<p class="el8SingleLineText">');
  if (opt_data.filedAsDocumentId) {
    output.append('<a class="item-details-trigger" data-id="', soy.$$escapeHtml(opt_data.filedAsDocumentId), '">');
    el8.template.ptdata.letterReceipts.subject(opt_data, output);
    output.append('</a>');
  } else {
    output.append('<span class="el8333">');
    el8.template.ptdata.letterReceipts.subject(opt_data, output);
    output.append('</span>');
  }
  output.append((opt_data.attachments.length) ? ' <img class="el8PaperClip" src="/static/images/transparent_16x16.png" />' : '', '</p></div><div class="filing-status"></div>', (opt_data.body) ? '<div class="el8FieldSection mt5">' + ((opt_data.isReferralLetter) ? '<label class="el8FieldMedium">Reason:</label><div class="letter-body el8FieldMediumLabelPadding el8Wrap el8StandardLineHeight el8StandardFontSize ' + ((el8Globals.PASSPORT_EMR) ? 'el8Preserve' : 'el8SingleLineText') + '">' + ((opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.body) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.body)) : soy.$$escapeHtml(opt_data.body))) + '</div>' : '<p class="letter-body ' + ((el8Globals.PASSPORT_EMR) ? 'el8Preserve' : 'el8SingleLineText') + ' mt10 mb20">' + ((opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.body) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.body)) : soy.$$escapeHtml(opt_data.body))) + '</p>') + '</div>' : '', '<div class="letter-collapsible-section ebs-form-horizontal"><div class="mb20">');
  if (opt_data.isReferralLetter) {
    el8.template.render.reportFeedItem.referralDetail.contentReferralOrderDetail({authNumber: opt_data.authNumber, authorizationFor: opt_data.authorizationFor, icd9CodeObjs: opt_data.icd9CodeObjs, icd10CodeObjs: opt_data.icd10CodeObjs}, output);
  }
  output.append('</div><div>');
  if (opt_data.attachments.length) {
    output.append('<div>Attachments</div>');
    el8.template.ptdata.letterReceipts.attachmentSection(opt_data, output);
  }
  output.append('</div>');
  if (opt_data.signDate) {
    output.append('<div class="mb5">');
    el8.template.render.signOff.summary(opt_data, output);
    output.append('</div>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letterReceipts.subject = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((! opt_data.isReferralLetter) ? 'Re: ' + ((! opt_data.subject) ? '(no subject)' : (opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.subject) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.subject)) : soy.$$escapeHtml(opt_data.subject))) : 'Re: Referral');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letterReceipts.feedIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.filedAsDocumentId || opt_data.isReferralLetter) ? '<div class="el8FeedItemIconConsult"></div>' : (opt_data.isPtLetter) ? '<div class="el8FeedItemIconPtLetter"></div>' : '<div class="el8FeedItemIconLetter"></div>', '<div class="el8StatusIconLetterReceipt"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letterReceipts.metadataCounts = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8NotesStatusWrap"><ul class="ebs-list-unstyled">', (opt_data.comments.length) ? '<li class="el8NotesStatusItem comments-icon' + ((opt_data.fromPracticeId != el8Globals.PRACTICE_ID && ! opt_data.readTime) ? ' el8Highlight' : '') + '"><span class="el8IconResponses"></span><span class="el8NotesStatusCount">' + soy.$$escapeHtml(opt_data.comments.length) + '</span></li>' : '', '</ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letterReceipts.attachmentSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol class="attachment-section padv5 ebs-list-unstyled">');
  var aList18696 = opt_data.attachments;
  var aListLen18696 = aList18696.length;
  for (var aIndex18696 = 0; aIndex18696 < aListLen18696; aIndex18696++) {
    var aData18696 = aList18696[aIndex18696];
    output.append((opt_data.signDate && (aData18696.attachmentType == 'Report' || aData18696.attachmentType == 'VisitNote' || aData18696.attachmentType == 'NonvisitNote' || aData18696.attachmentType == 'ReferralOrder' || aData18696.attachmentType == 'MessageThread')) ? '<li class="el8AttachmentListChart el8StandardFontSize ' + ((! aData18696.entityId) ? 'el8ItemHover' : '') + '"><div class="el8ItemButtonContainer">' + ((aData18696.entityId) ? '<span class="el8AttachmentStatus">Filed</span>' : '<button type="button" class="file-receipt-report el8ItemButton" data-id=' + soy.$$escapeHtml(aData18696.id) + '>File as Report</button>') + '</div>' : '<li class="el8AttachmentListChart el8StandardFontSize">', '<img class="el8PaperClip fl ebs-pull-left" src="/static/images/transparent_16x16.png"> ');
    el8.template.ptdata.letterReceipts.attachmentSummary(soy.$$augmentData(aData18696, {noHighlight: opt_data.noHighlight}), output);
    output.append('</li>');
  }
  output.append('</ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letterReceipts.attachmentSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.entityDate) ? '<span class="el8AttachmentDate">' + (soy.$$escapeHtml(opt_data.entityDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.entityDate)) : '') + '</span>' : '', '<span class="el8AttachmentTitle">');
  if (opt_data.entityId && el8Globals.APP == 'chart') {
    output.append('<a class="item-details-trigger" data-id="', soy.$$escapeHtml(opt_data.entityId), '">');
    el8.template.ptdata.letterReceipts._attachmentType(opt_data, output);
    output.append('</a>');
  } else if (opt_data.printableId) {
    output.append('<a class="view-inline-pdf', (opt_data.attachmentType == 'RefPanel') ? ' clinical-profile' : '', '" data-id="', soy.$$escapeHtml(opt_data.printableId), '">');
    el8.template.ptdata.letterReceipts._attachmentType(opt_data, output);
    output.append('</a>');
  } else {
    el8.template.ptdata.letterReceipts._attachmentType(opt_data, output);
  }
  output.append('</span><span class="el8AttachmentDescription">', (opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.summary) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.summary)) : soy.$$escapeHtml(opt_data.summary)), '</span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letterReceipts._attachmentType = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  switch (opt_data.attachmentType) {
    case 'RefPanel':
    case 'PatientDemog':
    case 'ImmHistory':
    case 'MedsList':
    case 'WhoHeightChart':
    case 'WhoWeightChart':
    case 'WhoHcChart':
    case 'CdcHeightChart':
    case 'CdcWeightChart':
    case 'CdcBmiChart':
    case 'CdcHcChart':
      el8.template.ptdata.letterReceipts.printoutTitle(opt_data, output);
      break;
    default:
      output.append((opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.entityDescription) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.entityDescription)) : soy.$$escapeHtml(opt_data.entityDescription)));
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letterReceipts.printoutTitle = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.noHighlight) {
    el8.template.ptdata.letters.attachments.rawTitleText({modelClass: opt_data.attachmentType}, output);
  } else {
    switch (opt_data.attachmentType) {
      case 'RefPanel':
        output.append((el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml('Clinical Profile')) : soy.$$escapeHtml('Clinical Profile')));
        break;
      case 'PatientDemog':
        output.append((el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml('Patient Demographics')) : soy.$$escapeHtml('Patient Demographics')));
        break;
      case 'ImmHistory':
        output.append((el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml('Immunization History')) : soy.$$escapeHtml('Immunization History')));
        break;
      case 'MedsList':
        output.append((el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml('Medications List')) : soy.$$escapeHtml('Medications List')));
        break;
      case 'WhoHeightChart':
      case 'WhoWeightChart':
      case 'WhoHcChart':
      case 'CdcHeightChart':
      case 'CdcWeightChart':
      case 'CdcBmiChart':
      case 'CdcHcChart':
        output.append((el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml('Growth Chart')) : soy.$$escapeHtml('Growth Chart')));
        break;
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letterReceipts.secondarySection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8ResponsesSection letter-responses-section mb5">');
  el8.template.ptdata.letterReceipts.commentSection(opt_data, output);
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letterReceipts.commentSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="letter-comments letter-responses-section">');
  if (opt_data.comments.length) {
    output.append('<div class="el8ResponsesHeader"><span class="comment-count">');
    el8.template.ptdata.letters.commentCount(opt_data, output);
    output.append('</span></div>');
  }
  output.append('<ul class="el8ResponsesWrap ebs-list-unstyled">');
  var cList18800 = opt_data.comments;
  var cListLen18800 = cList18800.length;
  for (var cIndex18800 = 0; cIndex18800 < cListLen18800; cIndex18800++) {
    var cData18800 = cList18800[cIndex18800];
    el8.template.ptdata.letters.comment(soy.$$augmentData(cData18800, {noHighlight: opt_data.noHighlight}), output);
  }
  el8.template.shared.commentReplyForm.replyTrigger(opt_data, output);
  output.append('</ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letterReceipts.noteSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Letter from ', soy.$$escapeHtml(opt_data.senderName), (opt_data.subject) ? ' re: ' + soy.$$escapeHtml(opt_data.subject) : '', ' on ', (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : ''));
  if (!opt_sb) return output.toString();
};
